import { Typography } from 'antd'
import { formatAddress } from '@/src/utils'

const { Text } = Typography

interface AddressLineProps {
  physicianAddress: string
  physicianCity: string
  physicianState: string
  physicianZip: string
  type?: 'secondary'
  isProfileCard?: boolean
}

export const AddressLine = ({
  physicianAddress,
  physicianCity,
  physicianState,
  physicianZip,
  type,
}: AddressLineProps) => {
  const address =
    physicianAddress &&
    formatAddress(physicianAddress, physicianCity, physicianState, physicianZip)
  return (
    <div data-testid='address-line' className='flex flex-col gap-0'>
      <Text
        type={type}
        className={
          type === 'secondary' ? 'custom-physician-bio-text ant-typography' : ''
        }
      >
        {typeof address === 'object' && address?.line1}
      </Text>
      <Text
        type={type}
        className={
          type === 'secondary' ? 'custom-physician-bio-text ant-typography' : ''
        }
      >
        {typeof address === 'object' && address?.line2}
      </Text>
    </div>
  )
}
